import React from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { FailedSolutions } from './FailedSolutions';
import { MechanismReveal } from './MechanismReveal';
import { SystemExplainer } from './SystemExplainer';
import { WhatYouGet } from './WhatYouGet';
import { WhoItsFor } from './WhoItsFor';
import { CTASection } from './CTASection';
import { Footer } from './Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-[#0f172a] text-[#faf5ef] selection:bg-[#d4a574] selection:text-[#0f172a]" data-id="element-145">
      <HeroSection data-id="element-146" />
      <PainSection data-id="element-147" />
      <FailedSolutions data-id="element-148" />
      <MechanismReveal data-id="element-149" />
      <SystemExplainer data-id="element-150" />
      <WhatYouGet data-id="element-151" />
      <WhoItsFor data-id="element-152" />
      <CTASection data-id="element-153" />

      <Footer data-id="element-154" />
    </main>;
}